import React from 'react'
import { Container } from './styles'
import { VictoryPie, VictoryAnimation, VictoryLabel } from 'victory'

const CircularProgress = ({ height, width, data, dataPercent }) => {
  return (
    <Container height={height} width={width}>
      <svg viewBox="0 0 280 250" width="100%">
        <VictoryPie
          standalone={false}
          animate={{ duration: 1000 }}
          width={280}
          height={250}
          data={data}
          innerRadius={100}
          cornerRadius={100}
          labels={() => null}
          style={{
            data: {
              fill: ({ datum }) => {
                return datum.x === 1 ? '#BE9137' : '#F0F0F0'
              }
            }
          }}
        />

        <VictoryAnimation duration={1000} data={dataPercent}>
          {(percent) => {
            return (
              <VictoryLabel
                textAnchor="middle"
                verticalAnchor="middle"
                x={140}
                y={120}
                text={`${Math.round(percent)}%`}
                style={{
                  fontSize: 45,
                  fill: '#858585',
                  fontWeight: 'bold'
                }}
              />
            )
          }}
        </VictoryAnimation>
      </svg>
    </Container>
  )
}

export default CircularProgress
